import { Skeletons } from "@callcenter/design-system"

import styles from "./user-account-form-skeleton.module.pcss"

export const UserAccountFormHeaderSkeleton = () => (
  <>
    <Skeletons.SkeletonLine isCircle width="60px" height="60px" />
    <div className={styles.headerUserNameSkeleton}>
      <Skeletons.SkeletonLine width="150px" height="24px" />
      <Skeletons.SkeletonLine width="240px" height="20px" />
    </div>
  </>
)
